const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.json');

module.exports = [{
    dataIndex: 0,
    id: '2pool',
    name: '2pool',
    lpTokenInfo: {
        name: '2Curve',
        symbol: '2Crv',
    },
    assets: 'DAI+USDC',
    coins: [
        coins.dai,
        coins.usdc,
    ],
    addresses: {
        swap: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        lpToken: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        gauge: '0x8866414733F22295b7563f9C5299715D2D76CAf4', // Unused
        old_gauge: '0x0a53FaDa2d943057C47A301D25a4D9b3B8e01e8E',
    },
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [{
        key: 'CRV2POOL',
        name: 'CRV',
        amountDataKey: 'crvRewards',
        rewardTokenAddress: '0x1E4F97b9f9F913c46F1632781732927B9019C68b',
        rewardTokenDecimals: 18,
        rewardContract: '0xb9c05b8ee41fdcbd9956114b3af15834fdedcb54',
        rewardTokenCoingeckoId: 'curve-dao-token',
    }],
    hasNoCRVRewards: true,
    hasGauge: true
}, {
    dataIndex: 1,
    id: 'fusdt',
    name: 'fUSDT',
    lpTokenInfo: {
        name: 'fusdtCurve',
        symbol: 'fusdtCrv',
    },
    coingeckoInfo: {
        id: 'tether',
        symbol: 'USDT',
    },
    assets: 'fUSDT+2pool',
    isMetaPool: true,
    coins: [
        coins.fusdt,
        coins.twocrv,
    ],
    metaCoins: [
        coins.dai,
        coins.usdc,
    ],
    addresses: {
        swap: '0x92d5ebf3593a92888c25c0abef126583d4b5312e',
        lpToken: '0x92d5ebf3593a92888c25c0abef126583d4b5312e',
        gauge: '0x06e3C4da96fd076b97b7ca3Ae23527314b6140dF',
        old_gauge: '0x4f3E8F405CF5aFC05D68142F3783bDfE13811522',
        deposit: '0xa42bd395f183726d1a8774cfa795771f8acfd777',
    },
    gaugeVersion: 3, // No CRV rewards
    additionalRewards: [{
        key: 'CRVFUSDT',
        name: 'CRV',
        amountDataKey: 'crvRewards',
        rewardTokenAddress: '0x1E4F97b9f9F913c46F1632781732927B9019C68b',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardContract: '0xfE1A3dD8b169fB5BF0D5dbFe813d956F39fF6310'
    }],
    hasNoCRVRewards: true,
    hasGauge: true

}, {

    dataIndex: 2,
    id: 'ren',
    name: 'ren',
    lpTokenInfo: {
        name: 'renCurve',
        symbol: 'renCrv',
    },
    coingeckoInfo: {
        id: 'renbtc',
        symbol: 'RENBTC',
        referenceAssetId: 'bitcoin',
    },
    assets: 'wBTC+renBTC',
    coins: [
        coins.wbtc,
        coins.renbtc,
    ],
    addresses: {
        swap: '0x3eF6A01A0f81D6046290f3e2A8c5b843e738E604',
        lpToken: '0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858',
        gauge: '0xBdFF0C27dd073C119ebcb1299a68A6A92aE607F0',
        old_gauge: '0x6600e98b71dabfD4A8Cac03b302B0189Adb86Afb'
    },
    gaugeVersion: 3, // No CRV rewards
    referenceAsset: REFERENCE_ASSETS.BTC,
    hasNoCRVRewards: true,
    additionalRewards: [{
        key: 'CRVREN',
        name: 'CRV',
        amountDataKey: 'crvRenRewards',
        rewardTokenAddress: '0x1E4F97b9f9F913c46F1632781732927B9019C68b',
        rewardTokenDecimals: 18,
        rewardTokenCoingeckoId: 'curve-dao-token',
        rewardContract: '0xfDb129ea4b6f557b07BcDCedE54F665b7b6Bc281'
    }],
  }
];
